import Fees from '@/components/booking-summary/Fees';
import NonTrips from '@/components/booking-summary/NonTrips';
import RefundTotal from '@/components/booking-summary/RefundTotal';
import Trips from '@/components/booking-summary/Trips';
import Vouchers from '@/components/booking-summary/Vouchers';
import { type BookingSummaryData } from '@/hooks/useBookingSummaryData';
import { useChangeBookingSelection } from '@/hooks/useChangeBookingSelection';
import type { FC } from 'react';

const SummaryContent: FC<Omit<BookingSummaryData, 'displayPrice'>> = ({
  inboundTrips,
  outboundTrips,
  nonTripOffers,
  fees,
  vouchers,
  passengersMap,
  travelAccountsMap,
  reservationFeesMap,
  refundTotal,
}) => {
  // The refund-total row is a UI-side aggregation of REFUNDED admissions.
  // In the change-booking flow the financial story is BE-driven (Change
  // total / Reusable sum), so we don't surface a self-calculated refund
  // there — it would double-count the same money under a computed label.
  const { hasSelection } = useChangeBookingSelection();
  return (
    <>
      {!!outboundTrips.length && (
        <Trips
          trips={outboundTrips}
          passengersMap={passengersMap}
          reservationFeesMap={reservationFeesMap}
          direction="outbound"
        />
      )}
      {!!inboundTrips.length && (
        <Trips
          trips={inboundTrips}
          passengersMap={passengersMap}
          reservationFeesMap={reservationFeesMap}
          direction="inbound"
        />
      )}
      {!!nonTripOffers.length && (
        <NonTrips
          nonTripsOffers={nonTripOffers}
          passengersMap={passengersMap}
          travelAccountsMap={travelAccountsMap}
        />
      )}
      {!!fees.length && <Fees fees={fees} />}
      {!!vouchers.length && <Vouchers vouchers={vouchers} />}
      {!hasSelection && !!refundTotal && (
        <RefundTotal refundTotal={refundTotal} />
      )}
    </>
  );
};

export default SummaryContent;
